import React, { Component } from 'react'
import { Route, Switch, Redirect } from 'react-router-dom'
import {
  AtcClassifications,
  Content,
  ContentEdit,
  ImagesTime,
  InteractionsType,
  Interactions,
  Laboratories,
  MedicationClassification,
  NotFound,
  Login,
  Users,
  ResetPassword,
  Medications,
  Specialities,
  MedicationsTypes,
  Probabilities,
  Keywords,
  DcbNames,
  Authors,
  Ratings,
  RatingDetails,
  ReadingTime,
  References,
  PreRegistration,
  Profiles,
  Severities,
  Cids,
  BookVectorization,
  ContentVectorization,
  VectorizationStatus,
  ContentsList,
  BookVectorSearch,
} from '../containers'
import PrivateRoute from './PrivateRoute'

export default class Routes extends Component {
  render() {
    return (
      <Switch>
        <PrivateRoute exact path="/" component={(router) => <Redirect to={'/conteudos'} />} />
        <PrivateRoute
          exact
          path="/sair"
          component={() => {
            return null
          }}
        />
        <PrivateRoute
          exact
          path="/conteudos"
          functionality={'conteudos'}
          component={(router) => <Content router={router} />}
        />
        <PrivateRoute
          exact
          path="/conteudos/:id"
          functionality={'conteudos'}
          component={(router) => <ContentEdit router={router} />}
        />
        <PrivateRoute
          exact
          path="/laboratorios"
          functionality={'laboratorios'}
          component={(router) => {
            return <Laboratories />
          }}
        />
        <PrivateRoute
          exact
          path="/medicamentos"
          functionality={'medicamentos'}
          component={(router) => {
            return <Medications />
          }}
        />
        <PrivateRoute
          exact
          path="/gravidades"
          functionality={'gravidades'}
          component={(router) => {
            return <Severities />
          }}
        />
        <PrivateRoute
          exact
          path="/classificacoes_medicamentos"
          functionality={'classificacoes_medicamentos'}
          component={(router) => {
            return <MedicationClassification />
          }}
        />
        <PrivateRoute
          exact
          path="/classificacoes_atc"
          functionality={'classificacoes_atc'}
          component={(router) => {
            return <AtcClassifications />
          }}
        />
        <PrivateRoute
          exact
          path="/interacoes_tipo"
          functionality={'interacoes_tipo'}
          component={(router) => {
            return <InteractionsType />
          }}
        />
        <Route
          exact
          path="/login"
          component={(router) => {
            return <Login />
          }}
        />
        <Route
          exact
          path="/redefinir-senha/:token"
          component={(router) => {
            return <ResetPassword />
          }}
        />
        <Route
          exact
          path="/redefinir-senha/"
          component={(router) => {
            return <ResetPassword />
          }}
        />
        <Route
          exact
          path="/cadastro-senha/:token"
          component={(router) => {
            return <ResetPassword cadastro={true} />
          }}
        />
        <PrivateRoute
          exact
          path="/usuarios"
          functionality={'usuarios'}
          component={(router) => {
            return <Users />
          }}
        />
        <PrivateRoute
          exact
          path="/perfis"
          functionality={'perfis'}
          component={(router) => {
            return <Profiles />
          }}
        />
        <PrivateRoute
          exact
          path="/especialidades"
          functionality={'especialidades'}
          component={(router) => {
            return <Specialities />
          }}
        />
        <PrivateRoute
          exact
          path="/tiposmedicamentos"
          functionality={'tiposmedicamentos'}
          component={(router) => {
            return <MedicationsTypes />
          }}
        />
        <PrivateRoute
          exact
          path="/probabilidades"
          functionality={'probabilidades'}
          component={(router) => {
            return <Probabilities />
          }}
        />
        <PrivateRoute
          exact
          path="/referencias"
          functionality={'referencias'}
          component={(router) => {
            return <References />
          }}
        />
        <PrivateRoute
          exact
          path="/autores"
          functionality={'autores'}
          component={(router) => {
            return <Authors />
          }}
        />
        <PrivateRoute
          exact
          path="/palavras-chave"
          functionality={'palavrasChave'}
          component={(router) => {
            return <Keywords />
          }}
        />
        <PrivateRoute
          exact
          path="/nomesdcb"
          functionality={'nomesDcb'}
          component={(router) => {
            return <DcbNames />
          }}
        />
        <PrivateRoute exact path="/cids" functionality={'cids'} component={(router) => <Cids />} />

        <PrivateRoute
          exact
          path="/vetorizacao-livros"
          functionality={'vetorizacaoLivros'}
          component={(router) => <BookVectorization />}
        />
        <PrivateRoute
          exact
          path="/vetorizacao-conteudos"
          functionality={'autores'}
          component={(router) => <ContentVectorization />}
        />
        <PrivateRoute
          exact
          path="/vetorizacao-status"
          functionality={'autores'}
          component={(router) => <VectorizationStatus />}
        />
        <PrivateRoute
          exact
          path="/vetorizacao-busca"
          functionality={'autores'}
          component={(router) => <BookVectorSearch />}
        />
        <PrivateRoute
          exact
          path="/conteudos-vetorizados"
          functionality={'autores'}
          component={(router) => <ContentsList />}
        />

        <PrivateRoute
          exact
          path="/interacoes"
          functionality={'interacoes'}
          component={(router) => {
            return <Interactions />
          }}
        />
        <PrivateRoute
          exact
          path="/avaliacoes"
          functionality={'avaliacoes'}
          component={(router) => {
            return <Ratings router={router} />
          }}
        />
        <PrivateRoute
          exact
          path="/avaliacoes/:id"
          functionality={'avaliacoes'}
          component={(router) => <RatingDetails router={router} />}
        />
        <PrivateRoute
          exact
          path="/pre_cadastros"
          functionality={'preCadastros'}
          component={(router) => <PreRegistration />}
        />
        <PrivateRoute
          exact
          path="/imagens_minutos"
          functionality={'imagens_minutos'}
          component={(router) => {
            return <ImagesTime />
          }}
        />
        <PrivateRoute
          exact
          path="/tempo_de_leitura"
          functionality={'tempos_leitura'}
          component={(router) => <ReadingTime />}
        />
        {/* Not Found Route */}
        <PrivateRoute
          component={(router) => {
            return <NotFound router={router} />
          }}
        />
      </Switch>
    )
  }
}



// WEBPACK FOOTER //
// ./src/routes/index.js